import {styled, Tooltip, tooltipClasses} from "@mui/material";
import {ErrorOutline} from "@mui/icons-material";
import * as React from "react";
import HelpIcon from "@mui/icons-material/Help";

export const DarkTooltip = styled(({ className, placement, ...props}) => (
  <Tooltip {...props} disableInteractive placement={placement} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 13,
    fontFamily: 'Arial',
  },
}));

export const TooltipErrorStyled = styled(({ className, placement, ...props}) => (
  <Tooltip {...props} disableInteractive placement={placement} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#333',
    border: '1px solid #ff0000',
    boxShadow: theme.shadows[1],
    fontSize: 13,
    fontFamily: 'Arial',
    marginBottom: '0px',
    cursor: 'pointer'
  },
}));

export const TooltipInfoStyled = styled(({ className, placement, ...props}) => (
  <Tooltip {...props} disableInteractive placement={placement} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 13,
    fontFamily: 'Arial',
  },
}));

export const ErrorTooltip = ({title, placement, sx}) => {
  return (
    <TooltipErrorStyled placement={placement || 'bottom'} sx={{fontSize: '16px'}} title={title}>
      <ErrorOutline sx={{color: '#ff0000', fontSize: '18px', pt: '12px', cursor: 'pointer', ...sx}}/>
    </TooltipErrorStyled>
  )
}

export const InfoTooltip = ({title, placement, sx}) => {
  return (
    <TooltipInfoStyled placement={placement || 'bottom'} sx={{fontSize: '16px'}} title={title}>
      <HelpIcon sx={{fontSize: '18px', pt: '12px', color: '#ccc', cursor: 'pointer', ...sx}}/>
    </TooltipInfoStyled>
  )
}